import { useMemo } from 'react'
import { useQuery } from 'react-query'
import { fetchAllFiles } from 'src/api/file/list'
import { fetchAllAnalysis } from 'src/api/analysis/list'
import { BATCHES_QUERY_KEY, BATCH_SCAN_LIMIT } from 'src/views/Batches/useBatches'
import { groupRows } from './model/samples'
import { analysedFileIds } from './model/candidates'

// The data behind the panel's "Uploaded, not analysed yet" list, for pages other
// than the panel (Home's "Ready to analyse"). Same queries and keys as the panel:
// the file list (['all-files'], useFiles) and the recent analyses the batches read
// ([BATCHES_QUERY_KEY]). No polling of its own: it reads the shared cache, which
// refetches in the background on mount and window focus, and follows whatever
// else polls or invalidates those keys (the panel, a start).

export const RECENT_ANALYSES_KEY = [BATCHES_QUERY_KEY]
export const fetchRecentAnalyses = () => fetchAllAnalysis({ page: 0, limit: BATCH_SCAN_LIMIT })
export const RECENT_ANALYSES_OPTIONS = { staleTime: 20 * 1000, keepPreviousData: true }

const useUploadedNotAnalysed = () => {
  const filesQuery = useQuery(['all-files'], fetchAllFiles, { refetchOnWindowFocus: true })
  const analysisQuery = useQuery(RECENT_ANALYSES_KEY, fetchRecentAnalyses, RECENT_ANALYSES_OPTIONS)
  const candidates = useMemo(() => groupRows(Array.isArray(filesQuery.data) ? filesQuery.data : []), [filesQuery.data])
  const analysed = useMemo(() => analysedFileIds(analysisQuery.data?.results || []), [analysisQuery.data])
  // Both lists are needed: without the analyses every upload would look new.
  const loaded = Array.isArray(filesQuery.data) && Boolean(analysisQuery.data)
  return { candidates, analysed, loaded }
}

export default useUploadedNotAnalysed
